import React, { useEffect, useState } from 'react';
import { Auth } from './components/Auth';
import { VisualReadOnlyHub } from './components/VisualReadOnlyHub';
import { ToastProvider } from './context/ToastContext';
import { User } from './types';
import { WORKSPACES } from './constants';
import { supabase, usuarioDesdeSesion } from './lib/supabase';

const App: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Restos del login anterior, que vivía solo en el navegador. Se limpian para que
    // una entrada vieja de localStorage no siga pareciendo una sesión válida.
    localStorage.removeItem('sdai_session_user');
    localStorage.removeItem('sdai_app_password');

    if (!supabase) {
      setLoading(false);
      return;
    }

    supabase.auth.getSession().then(({ data }) => {
      setUser(data.session?.user ? usuarioDesdeSesion(data.session.user) : null);
      setLoading(false);
    });

    // La sesión la mantiene Supabase y caduca sola. Si se cierra en otra pestaña,
    // esta se entera.
    const { data: subscripcion } = supabase.auth.onAuthStateChange((_evento, sesion) => {
      setUser(sesion?.user ? usuarioDesdeSesion(sesion.user) : null);
    });

    return () => subscripcion.subscription.unsubscribe();
  }, []);

  const handleLogin = (authenticatedUser: User) => {
    setUser(authenticatedUser);
  };

  const handleLogout = async () => {
    await supabase?.auth.signOut();
    setUser(null);
  };

  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center bg-[#0a0a0a] text-[#f5f2ec]">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#FF9800] border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Auth onLogin={handleLogin} />;
  }

  return (
    <ToastProvider>
      <VisualReadOnlyHub user={user} workspaceId={WORKSPACES[0].id} onLogout={handleLogout} />
    </ToastProvider>
  );
};

export default App;
